<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data,props.name,props.color);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

   let data=[
      {
         value: 60,
         name: '土地',
      },
      {
         value: 50,
         name: '田间',
      },
      {
         value: 50,
         name: '排水',
      },
      {
         value: 50,
         name: '灌溉',
      }
   ]

    this.state.chart.setOption({
      // backgroundColor: '#000',
         color: ['#36F097', '#3DFFDC', '#FFB956', '#268AFF', '#1ED6FF', '#ADE1FF'],
         tooltip: {
            trigger: 'item'
         },
         //   legend: {
         //     orient: 'horizontal',
         //     bottom:20,
         //     right:20,
         //     textStyle:{
         //        color:'#fff'
         //     }
         //   },
         grid: {
            left: '3%',
            right: '3%',
            bottom: '8%',
            top: '8%',
         },
         series: [
            {
               // name: 'Access From',
               type: 'pie',
               roseType: "radius",
               radius: '60%',
               center: ["50%", "48%"],
               itemStyle: {
                  // 需要间距时打开
                  // borderColor: '#000',
                  // borderWidth: 3,
                  shadowColor: 'rgba(0, 0, 0, 0.3)',
                  shadowBlur: 10
               },
			    label: { // 添加标签配置
			         show: true, // 显示标签
			         position: 'outside', // 设置标签位置，这里设置为'outside'表示在扇形外部显示
			         formatter: '{b}: {c} ({d}%)', // 格式化标签内容，其中'b'代表名称，'c'代表值，'d'代表百分比
			         color: '#fff', // 设置标签颜色
			       },
               data:data,
               labelLine: {
                  show: true,
                  lineStyle: {
                     color: '#fff',
                  },
               },
            }
         ]
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
